import React from "react";
import { userprofile } from "../../Model/Users"; //Include Home
import { withRouter, VirsionCheck } from "../../Helpers/Common"; //Include Home
import { UserchangeSendpin } from "../../Model/Users";
import { SVGIcons, ImgIcons } from "../../Helpers/Common";
import { motion } from "framer-motion";
import * as CountryCode from "../../Config/CountryCode.js";
import { UpdateProfile } from "../../Model/Users";
import { Link } from "react-router-dom";
import Profilemenu from "../Profile_menu/Profilemenu";
import { Mobilemenu } from "../Mobile_menu/Mobilemenu";
import { isMobile } from "react-device-detect";
import BarLoader from "react-spinners/BarLoader";
var SVGIcon = "";
var ImageData = "";
ImgIcons().then((result) => (ImageData = result));
SVGIcons().then((resultData) => (SVGIcon = resultData));
class Addname extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      fields: {
        fld_name: ""
      },
      ButtonDisable: true,
      errors: { isValidNameerror: false },
      VirsionCheckData: [],
      VirsionCheckDataloaded: false,
      SuccessNameChange: false
    };

    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    //Get Virsion Check Data
    VirsionCheck().then((vcheckres) => {
      let data = {
        seesionID:localStorage.getItem("session_id"),
        userID:localStorage.getItem("userID")
      }
      userprofile(data).then((userprofile) => {
        if (userprofile.data.success == false) {
          this.props.navigate("/createaccount");
        } else {
          this.setState({
            VirsionCheckData: vcheckres,
            VirsionCheckDataloaded: true,
            DataisLoaded: true,
            ProfileData: userprofile,
          });
        }
      });
    });
  }

  handleChange(e) {
    const fields = this.state.fields;

    if (e.target.name == "fld_name") {

      var errorState = this.state.errors;

      errorState["isValidNameerror"] = false;

      this.setState({ errorState });
      // var letters = /^[A-Za-z]+$/;
      // if (e.target.value.match(letters)) {

      //   this.setState({
      //     isValidMobile: true,
      //     ButtonDisable: false,
      //   });

      // } else {

      //   this.setState({
      //     isValidMobile: false,
      //     ButtonDisable: true,
      //   });
      // }

      this.setState({
        isValidMobile: true,
        ButtonDisable: false,
      });
    }

    fields[e.target.name] = e.target.value;
    this.setState({
      fields,
    });
  }
  CustomeBackButton() {
    this.setState({
      showEnterpin: false,
    });
  }
  /*-------Logout-------*/
  backbtn() {
    this.props.navigate("/profile");
  }
  popupshow() {

    this.setState({ SuccessMobileChange: true, showEnterpin: false });
  }

  /*--Uopdate profile---*/
  nameUpdate() {

    var Postdata = {
      name: this.state.fields.fld_name
    }
    UpdateProfile(Postdata).then((res) => {
      var resData = JSON.parse(res.data.message);
      if (resData.success == true) {
        { isMobile ? this.props.navigate("/manage-profile") : this.props.navigate("/profile") }
      } else {
        this.setState({
          SuccessNameChange: false
        })
      }
    })
  }

  headerText() {
    return (
      <div class="homeBanner">
        <div class="innerBanner mb-0">
          <div class="title-mail">
            <h1>
              Add <span className="red">Name</span>
            </h1>
            <div className="reset">
              Enter the name that will be linked to
              your DocuBay account where you'd want to receive all the updates.
            </div>
          </div>
        </div>
      </div>
    );
  }

  formSubmit() {
    return (
      <div className="temp31">
        <div className="temp31Inner">
          <div
            className={
              this.state.errors.isValidNameerror
                ? " formField error-border data"
                : true
                  ? "formField data "
                  : "formField data "
            }
            ref={this.emailInput}
          >
            <input
              type="text"
              name="fld_name"
              spellCheck="false"
              autoComplete="off"
              placeholder="Enter your full name"
              onChange={this.handleChange}
            />
          </div>
          {this.state.errors.isValidNameerror ? (
            <div className="error error-verifyotp">
              <img src={SVGIcon["error.svg"]} alt="DocuBay" />
              <p>{this.state.msg.alreadyRegiter} </p>
            </div>
          ) : null}
          <div
            className="passChangepopup"
            style={{
              display: this.state.SuccessNameChange
                ? "flex"
                : "none",
            }}
            id="passChange"
          >
            <div className="temp31-modal-body">
              <button
                className="temp31-modal-close temp31-modal-toggle"
                onClick={() => {
                  this.backbtn();
                }}
              >
                <img
                  src={SVGIcon["promocode-close.svg"]}
                  alt="DocuBay"
                />
              </button>
              <img
                src={ImageData["email.png"]}
                alt="DocuBay"
                className="imgPass"
              />
              <div className="temp31-awesome">
                <h5>Name changed!</h5>
                <h6>Your Name has been changed successfully</h6>
              </div>
              <Link
                to="/"
                type="submit"
                id="sendEnquiryBtn"
                className="btn-white"
              >
                Close
              </Link>
            </div>
          </div>

          <div className="formField mt-24 mb-24">
            <a href="#" className="temp31-modal-toggle">
              {" "}
              <button
                type="submit"
                id="sendEnquiryBtn"
                disabled={this.state.ButtonDisable}
                className={
                  this.state.ButtonDisable ? "btn-black" : "btn-red"
                }
                onClick={() => {
                  this.nameUpdate();
                }}
              >
                Submit
              </button>
            </a>
          </div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.VirsionCheckDataloaded == false) {
      // return <div className="loader"></div>;
      return <div className="loader"><BarLoader color="#ff000f" /></div>;
    } else {
      return (
        <>
          <motion.div
            className=""
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1 }}
            key="1"
          >
            <>
              <header className="dD-none">
                <div className="mainNav pmenu">
                  <div className="docubayBack white">
                    <Link to="/profile">
                      <img src="img/svg/back.svg" alt="DocuBay" />
                    </Link>{" "}
                    Add Name
                  </div>
                </div>
              </header>
              <main>
                <section className="mb-0 dD-none">
                  {this.headerText()}
                </section>
                <section style={{ paddingBottom: 45 }} className="dD-none">
                  {this.formSubmit()}
                </section>
              </main>            
              <div className="profile-back-desk dD-block">
                <Link to="/profile">
                  <div className="docubayBack white">
                    <img src={SVGIcon["back.svg"]} alt="DocuBay" />
                  </div>
                </Link>
              </div>
              <main className="setting-main dD-block">
                <section class="mb-0">
                  {this.headerText()}
                </section>
                <section style={{ paddingBottom: 45 }} className="dD-block">
                  {this.formSubmit()}
                </section>
              </main>
            </>
            {isMobile ? <Mobilemenu active="5" /> : <Profilemenu userdata={this.state.userData} />}
          </motion.div>
        </>
      );
    }
  }
}
export default withRouter(Addname);
